import { ReactComponent as Play } from 'assets/icons/icon-play.svg';

export default Play;
